import { Modal, ModalBody, ModalFooter } from "reactstrap";
import i_51 from "../../../assets/images/common/Frame 176 (1).svg";
import React from "react";
import './DisabledGamesModal.scss';
import { useTranslation } from "react-i18next";
import SwitchCheckboxInput from "../../../common/inputs/SwitchCheckboxInput";

const DisabledGamesModal = (props) => {
  const {
    isOpen,
    invalidGames,
    toggleModal,
    setInvalidGames,
    setIsEditDisabledGames,
    setState,
    initialInvalidGames,
  } = props;

  const { i18n } = useTranslation();

  const hasGamesChanged = (currentGames, initialGames) => {
    return currentGames.some((game, index) => {
      const initialGame = initialGames[index];
      if (!initialGame) return true;
      return (
        game.gameId !== initialGame.gameId ||
        game.remove !== (initialGame.remove || false)
      );
    });
  };

  const onToggleChange = (gameId, isChecked) => {
    setInvalidGames((prevInvalidGames) => {
      const updatedInvalidGames = prevInvalidGames.map((game) =>
        game.gameId === gameId ? { ...game, remove: !isChecked } : game
      );

      setState((prevState) => ({
        model: {
          ...prevState?.model,
          disabledGames: updatedInvalidGames.filter((game) => !game.remove),
        },
      }));

      setIsEditDisabledGames(hasGamesChanged(updatedInvalidGames, invalidGames));

      return updatedInvalidGames;
    });
  };

  const setToInitialStateInvalidGames = () => {
    toggleModal()
    setInvalidGames(initialInvalidGames?.current);
    setIsEditDisabledGames(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      data-toggle="modal"
      className="new-bonus-modal disabled-games-modal"
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title text-uppercase">
          {i18n.t('crm.manageDisabledGames')}
        </h5>
        <button className="close" onClick={setToInitialStateInvalidGames} />
      </div>

      <ModalBody>
        <div className="description-disabled-games">
          <span>{i18n.t('crm.modalDescriptionDisabledGames')}</span>
        </div>
        <div className="disabled-games-list">
          {invalidGames.map((game, index) => (
            <SwitchCheckboxInput
              key={index}
              checked={!game.remove}
              onChange={(isChecked) => onToggleChange(game.gameId, isChecked)}
              additionalClassName="mb-3 d-flex align-items-center switch-checkbox-reverse"
            >
              {`${game.name}  ${game.gameId}`}
            </SwitchCheckboxInput>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="footer-buttons">
          <button
            className="btn btn-primary btn-rounded w-100"
            onClick={toggleModal}
          >
            <img src={i_51} alt="" />
            {i18n.t('crm.submit')}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default DisabledGamesModal;